import React from "react";
import { useLang } from "../context/LangContext";
import { Target, Sliders, ClipboardCheck } from "lucide-react";

const COPY = {
  fr: {
    overline: "MÉTHODOLOGIE · 3 ÉTAPES",
    title: "Votre objectif au centre de la séance.",
    steps: [
      { n: "1", icon: Target, k: "Définir", d: "Un objectif concret est choisi avec vous : confort sur une zone ou aisance d'un mouvement." },
      { n: "2", icon: Sliders, k: "Personnaliser", d: "Une heure de prise en charge individuelle, avec les séquences adaptées à votre profil." },
      { n: "3", icon: ClipboardCheck, k: "Évaluer", d: "Le même mouvement et votre ressenti sont comparés en fin de séance pour faire le bilan." },
    ],
  },
  en: {
    overline: "METHODOLOGY · 3 STEPS",
    title: "Your objective at the heart of every session.",
    steps: [
      { n: "1", icon: Target, k: "Define", d: "A concrete objective is chosen with you: comfort on a specific area or ease of a movement." },
      { n: "2", icon: Sliders, k: "Personalise", d: "A 1-hour individual session with sequences tailored to your profile." },
      { n: "3", icon: ClipboardCheck, k: "Evaluate", d: "The same movement and your sensations are compared at the end of the session for a shared assessment." },
    ],
  },
  it: {
    overline: "METODOLOGIA · 3 FASI",
    title: "Il vostro obiettivo al centro della sessione.",
    steps: [
      { n: "1", icon: Target, k: "Definire", d: "Un obiettivo concreto è scelto insieme a voi: comfort su una zona o facilità di un movimento." },
      { n: "2", icon: Sliders, k: "Personalizzare", d: "Un'ora di gestione individuale, con le sequenze adattate al vostro profilo." },
      { n: "3", icon: ClipboardCheck, k: "Valutare", d: "Lo stesso movimento e le vostre percezioni sono confrontati alla fine della sessione per il bilancio." },
    ],
  },
  ru: {
    overline: "МЕТОДОЛОГИЯ · 3 ШАГА",
    title: "Ваша цель — в центре сеанса.",
    steps: [
      { n: "1", icon: Target, k: "Определить", d: "Конкретная цель выбирается вместе с вами: комфорт в зоне или лёгкость движения." },
      { n: "2", icon: Sliders, k: "Персонализировать", d: "Один час индивидуальной работы, с последовательностями, адаптированными под ваш профиль." },
      { n: "3", icon: ClipboardCheck, k: "Оценить", d: "То же движение и ваши ощущения сравниваются в конце сеанса для совместного подведения итогов." },
    ],
  },
};

export default function Methodology() {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.en;

  return (
    <section className="bg-[var(--surface-2)] hairline-t hairline-b py-20 md:py-24" data-testid="methodology">
      <div className="container-luxe">
        <div className="max-w-3xl mb-12">
          <div className="overline mb-3">{c.overline}</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-light text-[var(--ink)] leading-[1.05]">
            {c.title}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px hairline">
          {c.steps.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.n} className="bg-[var(--surface-1)] p-8 md:p-10 flex flex-col min-h-[240px]" data-testid={`step-${s.n}`}>
                <div className="flex items-center justify-between">
                  <Icon size={22} className="text-[var(--gold)]" />
                  <span className="font-display text-4xl md:text-5xl text-[var(--gold)]/25 font-light">{s.n}</span>
                </div>
                <div className="mt-auto pt-8">
                  <h3 className="font-display text-2xl text-[var(--ink)] font-light">{s.k}</h3>
                  <p className="mt-3 text-[14px] text-[var(--text-secondary)] leading-relaxed font-body">{s.d}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
